export default __webpack_public_path__ + "static/media/twitch.2154fb6d.svg";